import { render, staticRenderFns } from "./StepUserType.vue?vue&type=template&id=599be23a"
import script from "./StepUserType.vue?vue&type=script&lang=js"
export * from "./StepUserType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports